"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _curry = _interopRequireDefault(require("./internal/_curry1")),
    _identity2 = _interopRequireDefault(require("./internal/_identity"));

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var identity = (0, _curry["default"])(_identity2["default"]),
    _default = identity;
exports["default"] = _default;